module.exports = __webpack_public_path__ + "6cf28a98.svg";